// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content .no-notification-text[data-v-c02bd1d2] {\n  opacity: 0.75;\n  font-size: 20px;\n  max-width: 250px;\n}", ""]);
// Exports
module.exports = exports;
